import 'bootstrap'
import { initOnce, init } from './init'

document.addEventListener('DOMContentLoaded', () => {
    initOnce()
    init()
})